// Generated by scripts/build.mjs — do not edit.
export const version = {
  "tag": "",
  "sha": "b488fe99bd61132604e024f900e552761c7d005d",
  "shortSha": "b488fe9",
  "ref": "v0.2.4",
  "builtAt": "2026-08-20T20:10:17.024Z",
  "source": "git-describe"
};
